import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ContainerRead } from '../../entities/container.dto';
import { combineLatest, first, map, Observable, of, switchMap } from 'rxjs';
import { selectManyByPredicate } from '@ngneat/elf-entities';
import { asArraySafe } from '@pf/shared-utility';

@Injectable()
export class ContainerStore extends AbstractEntityStore<ContainerRead> {
    constructor() {
        super(PFWmsEntities.Container);
    }

    getTopLevelContainers$(): Observable<ContainerRead[]> {
        return this._store.pipe(
            selectManyByPredicate(c => !c.isDeleted && !c.parentContainerId)
        );
    }

    getContainersByParentId(parentId: string): Observable<ContainerRead[]> {
        return this._store.pipe(
            selectManyByPredicate(
                c =>
                    !c.isDeleted &&
                    !!c.parentContainerId &&
                    c.parentContainerId === parentId
            )
        );
    }

    getRootContainersByContainerTypeId(
        containerTypeId: string
    ): Observable<ContainerRead[]> {
        return this._store.pipe(
            selectManyByPredicate(
                c =>
                    !c.parentContainerId &&
                    c.containerType?.id === containerTypeId
            )
        );
    }

    getRootContainersByEquipmentTypeId(
        equipmentTypeId: string
    ): Observable<ContainerRead[]> {
        return this._store.pipe(
            selectManyByPredicate(
                c =>
                    !c.parentContainerId &&
                    c.equipment?.equipmentType?.id === equipmentTypeId
            )
        );
    }

    getAllChildren$(parentId: string): Observable<ContainerRead[]> {
        return this.getContainersByParentId(parentId).pipe(
            first(),
            switchMap(children => {
                return children.length
                    ? combineLatest(
                          asArraySafe(children).map(child =>
                              this.getAllChildren$(child.id)
                          )
                      ).pipe(
                          map(childrenArray =>
                              children.concat(childrenArray.flat())
                          )
                      )
                    : of([]);
            })
        );
    }
}
